import { Loader } from '@trackman/web-shared-components';
import React from 'react';
import { LoaderInner, LoadingOverlayWrapper } from './LoadingOverlayStyles';

const LoadingOverlay = () => {
  return (
    <LoadingOverlayWrapper>
      <LoaderInner>
        <Loader />
      </LoaderInner>
    </LoadingOverlayWrapper>
  );
};

export default LoadingOverlay;
